import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import Tooltip from '../../../control-components/ui-components/Tooltip'
import DeletePrivateMessage from './DeletePrivateMessage'
import ReportPrivateMessageButton from './ReportPrivateMessageButton'

interface Props {
  messageId: number
  userId: number
  conversationUser: {
    id: number
    username: string
  }
  messageContent: string
  canDelete: boolean
  setAlertMessage: (message: string) => void
  phrases: {
    delete: string
    errorMessage: string
  }
  onReport: () => void
}

class PrivateMessageTooltip extends PureComponent<Props> {
  render ({ messageId, canDelete, setAlertMessage, phrases, onReport }: Props) {
    const tooltipComponent = canDelete
      ? (
        <DeletePrivateMessage
          messageId={messageId}
          errorCallback={setAlertMessage}
          phrases={phrases}
        />
        )
      : <ReportPrivateMessageButton onReport={onReport} />

    return (
      <div className='private-message-tooltip'>
        <span className='text--meta'>
          <Tooltip
            trigger={<span className='icon--auto-width icon--ellipsis qa-private-message-ellipsis' />}
            tooltipMessage={tooltipComponent}
          />
        </span>
      </div>
    )
  }
}

export default PrivateMessageTooltip
